module.exports = __webpack_public_path__ + "img/32.b941713c.jpg";